<template>
	<span class="regFlotig">
	<div class=" position-absolute text-right floating-action-menu" :class="[{'active' : collapsed}]" style="bottom: 10px; right: 10px;" >
	
	  
	  <div class="d-block action-button"> 
		
		<!-- <button  class="btn-floating btn-primary" @click="onToggleCollapse" v-b-tooltip.hover title="Join">
		
		   <b-icon icon="person-plus" class="iconPuser"></b-icon>
		 
		</button> -->
		<b-link @click="showHideMap" >
		<button  class=" btn-primary-surveey" v-b-tooltip.hover title="Devices Map">
		 
		  <i class="fa fa-map-marker" aria-hidden="true"></i>
		</button>
		</b-link>
	  </div>
	</div>
	</span>
</template>
<script> 
/* const separator = {
  template: '<hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">'
}; */
	//var today 	= new Date();
	//var timenow = '?'+today.getHours()+ today.getMinutes()+today.getSeconds();
	
export default {
  name: 'MenuPanel',
  components: {
  
  },
  props: {
   
  },
  mounted(){
  //this.inLodcard;
	
  },
  computed: {
    //
  },
  data() {
    return{
     collapsed: false,

    }
  },
  methods:{
	/* inLodcard(){
	this.cartHeader ='
	} */
	showHideMap(){
		
		if(this.$root.mapshow==1){
			this.$root.mapshow =0
		}else{
			this.$root.mapshow=1;
		}
		
	},
	onToggleCollapse() {
			/* console.log('Ram Ram'+collapsed);
			this.collapsed = collapsed; */
			console.log('DataR'+this.collapsed);
			
			 if(this.collapsed){
				this.collapsed = false;
				
			 }else{
				this.collapsed = true;
				
			 }
			
			 /*this.posmenuProfile = collapsed;
			 this.navppnew = collapsed;
			 if(!collapsed){
				this.posmenu = true;
				
			 }else{
				this.posmenu = false;
				
			 }*/
		},
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
	.regFlotig{
		.btn-primary{
			
			width: 35px;
			height: 35px;
			position: fixed;
			border-radius: 50%;
			bottom: 10px;
			right: 8%;
			/*right: 20px;*/
			border: 0px;
			z-index: 9;
			color: red;
			background: #fff;
			border: 1px solid #010e1d;
				 
		}
		
		.btn-primary-surveey{
			
			width:35px;
			height:35px;
			position: fixed;
			border-radius: 50%;
			bottom: 10px;
			right: 5%;
			/*right: 20px;*/
			border: 0px;
			z-index: 9;
			color: red;
			background: #fff;
			border: 1px solid #010e1d;
			img{
				width:20px;
			}
				 
		}
		
		.floating-action{
			margin: 10px 0px;
		}
		.btn-dark{
			font-size: 10px;
		}
		
		div.floating-action-menu.active > .action-menu{
			visibility: visible;
			transform: translate(0);
			opacity: 1;
			padding-bottom: 5px;
			max-height: 1000px;
			position: fixed;
			bottom: 41px;
			right: 0px;
			z-index: 999;
		}
		.iconPuser{
			font-size:20px;
		}
	
	
	
	
	div.floating-action-menu.active > .action-button > .btn-floating:hover {
			/*background-color: red;
			border-color: #ff4c3b;*/
			
			color: #fff;
		}
		div.floating-action-menu.active > .action-button > .btn-floating {
			
			color: #fff;
		}
		
		
		.btn-primary:focus{
			box-shadow: none;
		}
		
		
	
	}
	@media only screen and (max-width:640px) {
			.regFlotig{
				.btn-primary{
					right: 32%;
				}
				
				.btn-primary-surveey{
					right: 21%;
				}
			}

	
	}
	div.floating-action-menu > .action-menu {
            visibility: hidden;
            transform: translateY(65px);
            opacity: 0;
            max-height: 0;
            overflow: hidden;

            transition: all 300ms linear;
        }
        div.floating-action-menu.active > .action-menu {
            visibility: visible;
            transform: translate(0);
            opacity: 1;
            padding-bottom: 5px;
            max-height: 1000px;
        }

        div.floating-action-menu > .action-menu > .floating-action {
            padding-right: 0.45rem;
        }

        div.floating-action-menu > .action-menu .btn-floating,
        div.floating-action-menu > .action-menu .badge
        {
            transform: scale(0.4);
            transition: all 500ms ease-in-out;
        }
        div.floating-action-menu.active > .action-menu .btn-floating,
        div.floating-action-menu.active > .action-menu .badge
        {
            transform: scale(1);
        }

        div.floating-action-menu > .action-button > .btn-floating {
            transition: all 500ms linear;
        }
        div.floating-action-menu.active > .action-button > .btn-floating {
            background-color: #dc3545;
            border-color: #dc3545;
        }
        div.floating-action-menu.active > .action-button > .btn-floating:hover {
            background-color: #c82333;
            border-color: #bd2130;
        }

        div.floating-action-menu > .action-button > .btn-floating > i {
            transition: transform 500ms ease-in-out;
        }
        div.floating-action-menu.active > .action-button > .btn-floating > i {
            transform: rotate(-315deg);

        }



</style>
